import { useState } from 'react';

import { useTitle } from 'my-core/hooks';

import FlashCardDeck from 'my-components/FlashCardDeck';
import InCourseExperienceHeader from 'my-components/OnlineCourse/InCourseExperience/InCourseExperienceHeader';
import CustomColorButton from 'my-elements/CustomColorButton';

import {
  StudentCoursePageBookletCard,
  StudentCoursePageCard,
  StudentCoursePageContentsWrapper,
  StudentCoursePageTwoColumnLayout,
} from './StudentCoursePageCommon';
import StudentCoursePageGradeBoostersList from './StudentCoursePageGradeBoostersList';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { faCommentExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SURVEY_LINK_PROPS = {
  component: 'a',
  nativeButton: false,
  href: 'https://form.typeform.com/to/nXnStE8D',
  target: '_blank',
  rel: 'noreferrer',
};

export default function StudentCoursePageFlashCards({
  assessments,
  classPass,
  course,
  courseSubscription,
  currentUser,
  drawerOpen,
  onlineCourses,
  onToggleDrawer,
  pathMatchData,
  studySessions,
  subscription,
  userCourse,
}) {
  useTitle(`${course?.code} Flashcards`);
  const [resultsPage, setResultsPage] = useState(false);
  return (
    <>
      <InCourseExperienceHeader
        drawerOpen={drawerOpen}
        onToggleDrawer={onToggleDrawer}
        rightActions={
          <Button startIcon={<FontAwesomeIcon icon={faCommentExclamation} />} {...SURVEY_LINK_PROPS}>
            Give Feedback
          </Button>
        }
        title={`${course?.code} Flashcards`}
        titleVariant="h6"
      />
      <StudentCoursePageContentsWrapper>
        <StudentCoursePageTwoColumnLayout>
          <div css={{ display: 'flex', flexDirection: 'column', alignItems: resultsPage ? 'stretch' : 'center' }}>
            <FlashCardDeck
              id={pathMatchData.params.id}
              isResultsPage={resultsPage}
              onSetIsResultsPage={setResultsPage}
            />
            {resultsPage && (
              <StudentCoursePageGradeBoostersList
                assessments={assessments}
                course={course}
                courseSubscription={courseSubscription}
                currentUser={currentUser}
                onlineCourses={onlineCourses}
                studySessions={studySessions}
                subscription={subscription}
                userCourse={userCourse}
              />
            )}
          </div>
          <div>
            {resultsPage && (
              <>
                <StudentCoursePageCard
                  sx={{
                    backgroundColor: 'purple.main',
                    display: 'flex',
                    flexDirection: 'column',
                    color: 'common.white',
                  }}
                >
                  <Typography variant="h6">Feedback</Typography>
                  <Typography sx={{ mb: 1.5 }}>
                    Tell us what you think about the flashcards for a chance to win $100 Amazon gift card.
                  </Typography>
                  <CustomColorButton color="white_purple" fullWidth variant="contained" {...SURVEY_LINK_PROPS}>
                    Take Survery!
                  </CustomColorButton>
                </StudentCoursePageCard>
                {classPass && (
                  <StudentCoursePageBookletCard
                    // className="oneColumnVisible"
                    classPassId={classPass.id}
                    course={course}
                  />
                )}
              </>
            )}
          </div>
        </StudentCoursePageTwoColumnLayout>
      </StudentCoursePageContentsWrapper>
    </>
  );
}
